<template>
	<div class="tool">
	  <div class="b-container" :class="{'klick_reaktion': 0==klick}"><button @click="neuesSpiel()" title="Neues Spiel" >
		<svg height="24px" viewBox="0 0 104 92" >
		  <g id="3.Multimedia" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round">
			<rect fill="#FF7171" x="0" y="0" width="100" height="88" rx="18"></rect>
			<path d="M37,26.8868147 C37,25.2334391 38.1509965,24.5861607 39.5682678,25.4395396 L67.8692915,42.4803815 C69.2877066,43.3344491 69.2865628,44.719855 67.8692915,45.5732339 L39.5682678,62.6140758 C38.1498526,63.4681434 37,62.8207339 37,61.1668007 L37,26.8868147 Z" id="Layer-2" fill="#FFFFFF"></path>
		  </g>
		</svg>
	  </button></div>
		<div class="b-container" :class="{'klick_reaktion': 9==klick}"><button @click="neuStart(9)" title="Neu starten">
			<svg width="24px" viewBox="0 0 487.622 487.622" >
				<circle style="fill:#65B3AD;" cx="243.811" cy="243.811" r="243.811"/>
				<path style="opacity:0.37;fill:#56A49E;enable-background:new    ;" d="M476.466,316.909L323.967,169.733l-67.121-30.225
					l-31.259-29.287l-6.776,39.59l-60.338,29.387l160.338,164.613l-75,24.379l-84.079-25.73l142.006,138.219
					C384.732,460.451,451.088,397.757,476.466,316.909z"/>
				<path style="fill:#FFFFFF;" d="M243.819,377.401c31.867,0,61.826-12.409,84.359-34.941c22.531-22.533,34.942-52.496,34.942-84.359
					c0-0.002,0,0.001,0-0.001c0-31.866-12.409-61.825-34.942-84.358c-16.023-16.023-36.13-27.103-58.147-32.041
					c-11.949-2.682-24.171-3.5-36.249-2.484l-8.195-28.994l-33.557,34.488l-33.557,34.488l46.646,11.816l46.646,11.816l-9.879-34.947
					c24.214-0.574,47.903,8.651,65.701,26.449c35.161,35.161,35.161,92.373,0,127.533c-35.161,35.161-92.372,35.161-127.532,0
					c-26.47-26.467-33.865-65.72-18.847-99.996l-26.674-11.688c-9.529,21.748-12.341,45.643-8.129,69.096
					c4.314,24.02,15.745,45.867,33.058,63.181C181.995,364.991,211.954,377.401,243.819,377.401z"/>
			</svg>
		</button></div>
	  <div class="b-container" :class="{'klick_reaktion': 1==klick}"><button @click="undo()" title="Zurück">
		<svg width="24px" viewBox="0 0 48 48" >
		  <g fill="rgb(216, 165, 99)">
			<polygon points="5,18 19,6.3 19,29.7"/>
			<path d="M28,14H16v8h12c2.8,0,5,2.2,5,5s-2.2,5-5,5h-3v8h3c7.2,0,13-5.8,13-13S35.2,14,28,14z"/>
		  </g>
		</svg>
	  </button></div>
	  <div class="b-container" :class="{'klick_reaktion': 2==klick}"><button @click="redo()" title="Vorwerts" >
		<svg width="24px" viewBox="0 0 48 48" >
		  <g fill="rgb(38, 189, 33)">
			<polygon points="43,18 29,6.3 29,29.7"/>
			<path d="M20,14h12v8H20c-2.8,0-5,2.2-5,5s2.2,5,5,5h3v8h-3c-7.2,0-13-5.8-13-13S12.8,14,20,14z"/>
		  </g>
		</svg>
	  </button></div>
	  <div class="b-container" :class="{'klick_reaktion':5==klick}"><button @click="setFaktor(-0.5)">
		<svg width="24px" viewBox="0 0 24 24" fill="none" stroke="#1245C6" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" 
		class="feather feather-plus-square">
		<rect x="1" y="1" width="22" height="22" rx="4" ry="4" stroke-width="2" ></rect>
		<line x1="6" y1="12" x2="18" y2="12"></line>
		</svg>
	  </button></div>
	  <div class="b-container" :class="{'klick_reaktion': 6==klick}"><button @click="setFaktor(0.5)">
		<svg width="24px" viewBox="0 0 24 24" fill="none" stroke="#1245C6" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" 
		class="feather feather-plus-square">
		<rect x="1" y="1" width="22" height="22" rx="4" ry="4" stroke-width="2"></rect>
		<line x1="12" y1="6" x2="12" y2="18"></line>
		<line x1="6" y1="12" x2="18" y2="12"></line>
		</svg>
	  </button></div>
	</div>
	<div class="container" :style="styCont">
		<div>
			<span class="karten-cont" :style="styCell">
				<Karte v-if="stappel.length"  bild="verso" @click="verteilen" />
			</span>
			<span
				@dragover="prevDefault"
				@drop="onDropAblage($event, {ablage: true})"
				
			>
				<span class="karten-cont" :style="styCellAb" v-for="(col, a_idx) in ablage" :key="a_idx"
				@pointerdown="markieren({karte: col[0], a_idx})"
				>
					<Karte v-if="col[0]" :bild="col[0]" @dragstart="onDragStart($event, {karte: col[0], a_idx} )" />
				</span>
			</span>
		</div>
		<div class="feld-cont">
			<div :style="styRow" v-for="(row, r_idx) in feld" :key="r_idx" :data-row="r_idx">
				<span class="karten-cont" :style="styCell"  v-for="(karte, c_idx) in row" :key="r_idx * 10 + c_idx"
				:data-cell="r_idx+','+c_idx"
					@dragover="prevDefault"
					@drop="onDrop($event, {karte, r_idx, c_idx})"
					@dblclick="zuAblage(karte, r_idx, c_idx)"
					@pointerdown="markieren({karte, r_idx, c_idx})"
				>
					<Karte v-if="karte" :bild="karte" @dragstart="onDragStart($event, {karte, r_idx, c_idx} )" />
					<span v-else-if="r_idx==0" class="leer-cont" :style="styCellAb" 
						@dragover="prevDefault"
						@drop="onDrop($event, {karte: '', r_idx, c_idx})"
					></span>
				</span>
			</div>
		</div>
	</div>
</template>

<script setup>
	import { ref, computed, inject, onMounted } from 'vue';
	import {sd} from '@/helper/PasientaData'
	import Karte from '@/components/Karte.vue';
  import {karten} from '@/helper/karten';

	let faktor = inject('groesse');
	const klick = ref(-1);

	const emit = defineEmits(['change-groesse'])
	const term = 0.07;

	const styCont = computed(() => 'width:' + (faktor.value * 176 * term * 9 + 80) 
	+ 'px; height:'+ ((faktor.value * 270 * 2 * term) + (faktor.value * 3 * feld.value.length) + 40) + 'px;');
	const styRow = computed(() => 'height:' + (faktor.value * 3) + 'px;');
	const styCell = computed(() => 'width:' + (faktor.value * 176 * term) + 'px;');
	const styCellAb = computed(() => 'width:' + (faktor.value * 176 * term) + 'px; height:'+ (faktor.value * 270 * term) + 'px;');
	let ablauf = [];
	let mGruppe = [];

	const raster = [];
	for(let k = 0; k < 5; k++) {
		const data = [];
		raster.push(data);
		for(let j = 0; j < 9; j++) {
			data.push('');
		}
	}
	const feld = ref(JSON.parse(JSON.stringify(raster)));
	const stappel = ref([]);
	const ablage = ref([[''], [''], [''], [''], [''], [''], [''], ['']]);

	sd.init(feld, stappel, ablage);

	onMounted(() => {
		neuesSpiel();
	})

	function neuesSpiel() {
		klick.value = 0;
		setTimeout(() => { klick.value = -1; }, 100);
		ablauf = sd.spiel.map( (w,i) => ({w, s: Math.random()}));
		ablauf.sort((a, b) => a.s - b.s);
		ablauf = ablauf.map((a) => { a.s = Math.random(); return a});
		ablauf.sort((a, b) => a.s - b.s);
		neuStart(-1);
	}

	function neuStart(arg) {
		klick.value = arg;
		setTimeout(() => { klick.value = -1; }, 100);
		const reihe = ablauf.map(r => r.w);
		let i1 = 0, i2 = 8, wert;
		const felder = JSON.parse(JSON.stringify(raster));
		for(let k = 0; k < 5; k++) {
			for(let j = i1; j < i2 + 1; j++) {
				wert = reihe.shift();
				if (j === i1 || j === i2) {
					felder[k][j] = wert.substring(1);
				} else {
					felder[k][j] = wert;
				}
			}
			i1++;
			i2--;
		}
		feld.value = felder;
		stappel.value = reihe;
		ablage.value = [[''], [''], [''], [''], [''], [''], [''], ['']];
		sd.zuege = [];
		sd.idx = 0;

		// console.log(JSON.parse(JSON.stringify(feld.value)), JSON.parse(JSON.stringify(stappel.value)))
	}

	function undo() {
		klick.value = 1;
		setTimeout(() => { klick.value = -1; }, 100);
		sd.undoZug();
	}

	function redo() {
		klick.value = 2;
		setTimeout(() => { klick.value = -1; }, 100);
		sd.redoZug();
	}

	function setFaktor(f) {
		klick.value = f==0.5 ? 6 : 5;
		setTimeout(() => { klick.value = -1; }, 100);
		emit('change-groesse', f)
	}

	function select(g, clean) {
		let karte;
		if (g.a_idx !== undefined) {
			karte = ablage.value[g.a_idx][0];
		} else {
			karte = feld.value[g.r_idx][g.c_idx];
		}
		if (clean && (karte.charAt(3) === '0' || karte.charAt(3) === '1')) {
			return karte
		}
		if (karte.charAt(3) === '0') {
			karte = karte.substring(0,3) + '2'
		} else if (karte.charAt(3) === '1') {
			karte = karte.substring(0,3) + '3'
		} else if (karte.charAt(3) === '2') {
			karte = karte.substring(0,3) + '0'
		} else if (karte.charAt(3) === '3') {
			karte = karte.substring(0,3) + '1'
		}
		if (g.a_idx !== undefined) {
			ablage.value[g.a_idx][0] = karte;
		} else {
			feld.value[g.r_idx][g.c_idx] = karte;
		}
		return karte
	}


	function markieren(arg) {
		if (arg.karte && arg.karte.charAt(0) !== 'v') {
			const gruppe = arg.a_idx !== undefined ? [arg] : sd.gruppe(feld, arg.r_idx, arg.c_idx);
			if (gruppe.length) {
				if (mGruppe.length) {
					mGruppe.forEach( g => {
						select(g, true)
					})
					if (sd.istParent(arg.karte, mGruppe[0].karte)) {
						if (arg.r_idx + 1 === sd.idxFrei(feld, arg.c_idx)) {
							doTransfer(mGruppe, arg.r_idx, arg.c_idx);
							return;
						}
					}
				}
				mGruppe = gruppe;
				mGruppe.forEach( g => {
					select(g)
				})
			}
		} else if (arg.karte === '' && mGruppe.length && arg.r_idx === 0) {
			arg.r_idx--;
			doTransfer(mGruppe, arg.r_idx, arg.c_idx)
			return;
		}
	}

	function clearSelect() {
		mGruppe.forEach( g => {
			select(g, true)
		})
		mGruppe = [];
	}

  function onDragStart(ev, arg) {
		if (!arg.karte || arg.karte.charAt(0) === 'v') {
			ev.preventDefault();
		} else {
			const breite = faktor.value * 176 * term;
			const hoehe = faktor.value * 270 * term;
			const delta = faktor.value * 3;
			const gruppe = arg.a_idx !== undefined ? [arg] : sd.gruppe(feld, arg.r_idx, arg.c_idx);
			if (!gruppe.length) {
				ev.preventDefault();
			} else {
				ev.dataTransfer.setData('id', JSON.stringify(gruppe));
				const canvas = document.createElement('canvas');
				canvas.width = breite;
				canvas.height = hoehe + delta * (gruppe.length - 1);
				const ctx = canvas.getContext('2d');
				const image = new Image();
				let y = 0;
				gruppe.forEach( g => {
					image.src = karten[g.karte.substring(0, 3)];
					ctx.drawImage(image, 0, y, breite, hoehe);
					y += delta;
				})
				ev.dataTransfer.setDragImage(canvas, 25, 10)
			}
		}
  }

	function onDropAblage(ev, arg) {
		const {karte, r_idx, c_idx} = JSON.parse(ev.dataTransfer.getData('id'));
		zuAblage(karte, r_idx, c_idx)
	}

	function onDrop(ev, arg) {
		const gruppe = JSON.parse(ev.dataTransfer.getData('id'));
		let {r_idx, c_idx} = arg;
		if ( sd.istParent(arg.karte, gruppe[0].karte) ) {
			if (r_idx + 1 === sd.idxFrei(feld, c_idx)){
				doTransfer(gruppe, r_idx, c_idx)
			}
		} else if (arg.karte === '' && arg.r_idx === 0) {
			r_idx--;
			doTransfer(gruppe, r_idx, c_idx)
		}
	}

	function doTransfer(gruppe, r_idx, c_idx) {
		clearSelect()
		gruppe.forEach((g, idx) => {
			r_idx++;
			if (r_idx >= feld.value.length) {
				feld.value.push(['', '', '', '', '', '', '', '', ''])
			}
			feld.value[r_idx][c_idx] = select(g, true);
			if (g.a_idx !== undefined) {
				ablage.value[g.a_idx].shift();
				const karte = 'v' + g.karte;
				if (idx === 0) {
					sd.insZug({ a_idx: g.a_idx }, { karte, r_idx, c_idx });
				} else {
					sd.addZug({ a_idx: g.a_idx }, { karte, r_idx, c_idx });
				}
			} else {
				feld.value[g.r_idx][g.c_idx] = '';
				const karte = 'v' + g.karte;
				if (idx === 0) {
					sd.insZug({ karte: '', r_idx: g.r_idx, c_idx: g.c_idx }, { karte, r_idx, c_idx });
				} else {
					sd.addZug({ karte: '', r_idx: g.r_idx, c_idx: g.c_idx }, { karte, r_idx, c_idx });
				}
			}
		});
		sd.zeigeVerso(feld, gruppe[0].r_idx - 1, gruppe[0].c_idx);
	}

  function prevDefault(ev) {
		ev.preventDefault()
  }

	function verteilen() {
		sd.bewegungen = [];
		let idx = 0;
		for (let c_idx = 0; c_idx < 9; c_idx++) {
			if (/^14/.test(feld.value[0][c_idx])) {
				continue;
			}
			const karte = stappel.value.shift();
			if (karte) {
				const r_idx = sd.idxFrei(feld, c_idx);
				if ( idx++ === 0) {
					sd.insZug({stappel: true}, {karte, r_idx, c_idx})
				} else {
					sd.addZug({stappel: true}, {karte, r_idx, c_idx})
				}
				sd.bewegungen.push({r_idx, c_idx, karte: karte.substring(1)});
				clearSelect()
			} else {
				break;
			}
		}
		sd.bewegen();
	}

	function zuAblage(karte, r_idx, c_idx) {
		if (karte && karte.charAt(0) !== 'v') {
			if (r_idx + 1 === sd.idxFrei(feld, c_idx) ) {
				karte = select({karte, r_idx, c_idx}, true)
				const f_idx = sd.idxFolge(karte);
				if (f_idx !== -1) {
					for (let a_idx = 0; a_idx < 8; a_idx++) {
						if (f_idx === 0 && ablage.value[a_idx][0] === '') {
							ablage.value[a_idx].unshift(karte);
							feld.value[r_idx][c_idx] = '';
							karte = 'v' + karte;
							sd.insZug({karte, r_idx, c_idx}, {a_idx});
							sd.zeigeVerso(feld, r_idx - 1, c_idx);
							clearSelect()
							return;
						} else if (ablage.value[a_idx][0] && karte.charAt(2) === ablage.value[a_idx][0].charAt(2) && f_idx - 1 === sd.idxFolge(ablage.value[a_idx][0])) {
							ablage.value[a_idx].unshift(karte);
							feld.value[r_idx][c_idx] = '';
							karte = 'v' + karte;
							sd.insZug({karte, r_idx, c_idx}, {a_idx});
							sd.zeigeVerso(feld, r_idx - 1, c_idx);
							clearSelect()
							return;
						}
					}
				}
			}
		}
	}
</script>

